// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://videvqtlwuoeyemuhyqy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpZGV2cXRsd3VvZXllbXVoeXF5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5MTA0NDIsImV4cCI6MjA1NzQ4NjQ0Mn0.Fd9ZH_XiP5m3sN6kx5uHfXBvr1WC-V55k8r_8dGVxaw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);